import { createApp } from 'vue';
import ElementPlus from 'element-plus';
import 'element-plus/dist/index.css';
import App from './App.vue';
import './styles/main.css';
import i18n from './i18n';
// import { createRouter, createWebHistory } from 'vue-router';

// const routes = [
//   { path: '/', component: () => import('./App.vue') },
//   { path: '/auth/cognito/callback', component: () => import('./components/AuthComponent.vue') },
// ];

// const router = createRouter({
//   history: createWebHistory(),
//   routes,
// });

const app = createApp(App);


app.use(ElementPlus);
app.use(i18n);
//app.use(router);

// 设置全局 i18n 实例，供 composables 使用
window.__VUE_I18N__ = i18n;

app.mount('#app');
